<div class="row card">
  <div class="col-12 card-body">
    <div class="page-loading-wrapper d-flex flex-column align-items-center justify-content-center">
      @switch (loadingState) {
        @case (pageLoadingState.loading) {
          <ds-page-message
            *featureFlag="FeatureFlagCollection.dsPageMessage"
            [title]="'page_loading' | translate"
            [toggleBody]="true"
            [toggleAction]="false"
            [togglePadding]="false"
            titleHeadingStyle="h3"
          >
            <div ds-page-message-visual role="status" aria-live="polite">
              <ds-loading-spinner
                [size]="DsLoadingSpinnerSize.Large"
                [variant]="DsLoadingSpinnerVariant.Gray"
                [label]="'page_loading' | translate"
              ></ds-loading-spinner>
            </div>
            <div ds-page-message-body>{{ 'page_loading_description' | translate }}</div>
          </ds-page-message>
          <ng-container *featureFlag="revertFlag(FeatureFlagCollection.dsPageMessage)">
            <svg height="80" aria-hidden="true">
              <use xlink:href="#page-loading"></use>
            </svg>
            <h3 class="margin-top-lg mb-3">{{ 'page_loading' | translate }}</h3>
            <p>{{ 'page_loading_description' | translate }}</p>
            <p></p>
          </ng-container>
        }
        @case (pageLoadingState.error) {
          <ds-page-message
            *featureFlag="FeatureFlagCollection.dsPageMessage"
            [title]="'page_loading_error' | translate"
            [pageMessageIcon]="Icons.LoadWarningBrand"
            [iconColor]="DsColors.Primary"
            [iconScale]="IconScale.FA_4X"
            [iconStyle]="IconStyles.Light"
            [toggleBody]="true"
            [toggleAction]="true"
            [togglePadding]="false"
            titleHeadingStyle="h3"
          >
            <div ds-page-message-body [innerHTML]="'page_loading_error_description' | translateHtml"></div>
            <div ds-page-message-action class="d-flex justify-content-center">
              <button ds-button [variant]="DsButtonVariants.primary" type="button" (click)="reloadPage()">
                {{ 'reload_this_page' | translate }}
              </button>
            </div>
          </ds-page-message>
          <ng-container *featureFlag="revertFlag(FeatureFlagCollection.dsPageMessage)">
            <svg height="80" aria-hidden="true">
              <use xlink:href="#page-loading-error"></use>
            </svg>
            <h3 class="margin-top-lg mb-2">{{ 'page_loading_error' | translate }}</h3>
            <p class="text-center" [innerHTML]="'page_loading_error_description' | translateHtml"></p>
            <p>
              <a [routerLink]="['/', Api.portfolio]">
                <button class="btn btn-primary" type="button" (click)="reloadPage()">{{ 'reload_this_page' | translate }}</button>
              </a>
            </p>
          </ng-container>
        }
      }
    </div>
  </div>
</div>
